<template>
  <div>
    <WorkspaceCreate @changeStep="changeStep" v-show="step == 1" />
  </div>
</template>

<script>
import WorkspaceCreate from './WorkspaceCreate';

export default {
  components: {
    WorkspaceCreate,
  },
  data() {
    return {
      loaded: false,
      step: 1,
      workSpaceName: '',
      workSpacePesonal: {
        'workspace': {
          'id': null,
          'name': 'Personal'
        }
      }
    };
  },
  methods: {
    changeStep(step, name = '') {
      if (step === 2) {
        this.$store
          .dispatch('createWorkspace', { name })
          .then(() => this.$router.push({ name: 'workspace.login' }));
      }
    },
  },
  created() {
    setTimeout(() => {
      let docClasses = document.body.classList;
      docClasses.add('white-content');
    }, 100);
  },
  beforeMount() {
    if (this.$route.query.step == 1) {
      this.step = this.$route.query.step;
    }
  }
};
</script>
